import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../common/Footer";
import Navbar from "../common/Navbar";
import ServiceContent from "../components/service/ServiceContent";
import { Helmet } from "react-helmet";

const Service = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, [location.pathname]);

  console.log("locationioio", location)

  return (
    <>
      <Helmet>
        <meta
          name="keywords"
          content="business promotion company in Chennai,
                  business promotion company in India,
                  bulk whatsapp service in Chennai,
                  bulk whatsapp service in India,
                  whatsapp marketing company Chennai,
                  whatsapp marketing company India,
                  whatsapp api provider Chennai,
                  whatsapp api provider India,
                  whatsapp business api service Chennai,
                  whatsapp business api service India,
                  bulk whatsapp sender tool Chennai,
                  bulk whatsapp sender tool India,
                  whatsapp marketing software Chennai,
                  whatsapp marketing software India,
                  whatsapp automation for business Chennai,
                  whatsapp automation for business India,
                  whatsapp broadcast marketing Chennai,
                  whatsapp broadcast marketing India,
                  whatsapp campaign management Chennai,
                  whatsapp campaign management India,
                  increase sales through digital marketing Chennai,
                  increase sales through digital marketing India"
        />

      </Helmet>
      <Navbar />
      <ServiceContent />
      <Footer />
    </>
  );
};

export default Service;
